module.exports = __webpack_public_path__ + "7affffa351ca0224f4821800c51dc7d2.svg";